module.exports = __webpack_public_path__ + "img/MEDIA022.66a69ce3.jpg";